import { useState, useEffect } from "react";
import { Bell, BadgeCheck, Car, Users, HelpCircle, MessageCircle, Shield } from "lucide-react";
import { api } from "@/lib/api";

const TYPE_ICONS = {
  verification: BadgeCheck, ride_request: Car, ride_accepted: Car, ride_rejected: Car, ride_cancelled: Car,
  buddy_request: Users, buddy_accepted: Users, are_you_going: HelpCircle, comment: MessageCircle, admin: Shield,
};

export default function Notifications() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/notifications").then(({ data }) => {
      setItems(data);
      api.post("/notifications/mark-read").catch(() => {});
    }).catch(() => setItems([]));
  }, []);

  if (items === null) return <p className="text-muted-foreground animate-pulse text-center py-10">Loading…</p>;

  return (
    <div className="max-w-xl mx-auto space-y-4" data-testid="notifications-page">
      <h1 className="font-display font-black text-3xl">Notifications</h1>
      {items.length ? (
        <div className="t-card divide-y divide-black/5">
          {items.map((n) => {
            const Icon = TYPE_ICONS[n.type] || Bell;
            return (
              <div key={n.id} className={`flex gap-3 p-4 ${!n.read ? "bg-primary/[0.03]" : ""}`} data-testid={`notification-${n.id}`}>
                <div className="w-9 h-9 rounded-full bg-[#F9C31F]/60 flex items-center justify-center shrink-0">
                  <Icon className="w-4 h-4 text-[#12211C]" />
                </div>
                <div className="min-w-0">
                  <p className="font-bold text-sm">{n.title}</p>
                  <p className="text-sm text-muted-foreground">{n.body}</p>
                  <p className="text-xs text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString()}</p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="t-card p-10 text-center" data-testid="empty-notifications">
          <Bell className="w-8 h-8 mx-auto text-muted-foreground" />
          <p className="font-display font-bold mt-3">All caught up</p>
          <p className="text-sm text-muted-foreground mt-1">Ride requests, buddy asks and updates will land here.</p>
        </div>
      )}
    </div>
  );
}
